export default [
  // Home
  {
    path: '/',
    name: 'home',
    component: () => import('@/components/home/Home')
  },

  // 404
  {
    path: '/error/404',
    name: '404',
    component: () => import('@/components/404/404')
  },

  // Regions
  {
    path: '/regions/:region',
    name: 'region', // english version
    component: () => import('@/components/home/Home')
  },
  {
    path: '/regions/:region/:subregion',
    name: 'subregions', // english version
    component: () => import('@/components/home/Home')
  },
  {
    path: '/bezirke/:region',
    name: 'bezirk', // german version
    component: () => import('@/components/home/Home')
  },
  {
    path: '/bezirke/:region/:subregion',
    name: 'unterbezirk', // german version
    component: () => import('@/components/home/Home')
  },

  // Home with region
  {
    path: '/home/:region',
    name: 'homeregion',
    component: () => import('@/components/home/Home')
  },

  // Pages
  {
    path: '/page/:title/:id',
    name: 'page', // english version
    component: () => import('@/components/page/Page')
  },
  {
    path: '/page/region/:region/:title/:id',
    name: 'pageregion', // english version
    component: () => import('@/components/page/Page')
  },
  {
    path: '/seite/:title/:id',
    name: 'seite', // german version
    component: () => import('@/components/page/Page')
  },
  {
    path: '/seite/bezirk/:region/:title/:id',
    name: 'seitebezirk', // german version
    component: () => import('@/components/page/Page')
  },

  // Articles
  {
    path: '/article/:title/:id/:pid',
    name: 'article', // english version
    component: () => import('@/components/article/Article')
  },
  {
    path: '/artikel/regions/:region/:title/:id/:pid',
    name: 'articleregion', // german version
    component: () => import('@/components/article/Article')
  },
  {
    path: '/artikel/:title/:id/:pid',
    name: 'artikel', // german version
    component: () => import('@/components/article/Article')
  },
  {
    path: '/artikel/bezirke/:region/:title/:id/:pid',
    name: 'artikelbezirke', // german version
    component: () => import('@/components/article/Article')
  },

  // Poll
  {
    path: '/poll/:title/:id/:pid',
    name: 'poll', // english version
    component: () => import('@/components/polls/Polls')
  },
  {
    path: '/umfrage/regions/:region/:title/:id/:pid',
    name: 'umfrageregion', // german version
    component: () => import('@/components/polls/Polls')
  },
  {
    path: '/umfrage/:id',
    name: 'umfrage', // german version
    component: () => import('@/components/polls/Polls')
  },
  {
    path: '/umfrage/bezirke/:region/:title/:id/:pid',
    name: 'umfragebezirke', // german version
    component: () => import('@/components/polls/Polls')
  },

  // Social
  {
    path: '/social',
    name: 'social', // german version
    component: () => import('@/components/social/Social')
  },

  // Marketplace
  {
    path: '/:region/marktplatz',
    name: 'martplatzliste', // german version
    props: {'list':'all', 'content':'all'},
    component: () => import('@/components/marketplace/Marketplacelist')
  },
  {
    path: '/:region/marktplatz/verein_gesucht',
    name: 'clubliste', // german version
    props: {'list':'club', 'content':'club'},
    component: () => import('@/components/marketplace/Marketplacelist')
  },
  {
    path: '/:region/marktplatz/turniere',
    name: 'turnierliste', // german version
    props: {'list':'contest', 'content':'contest'},
    component: () => import('@/components/marketplace/Marketplacelist')
  },
  {
    path: '/:region/marktplatz/trainer_gesucht',
    name: 'trainerliste', // german version
    props: {'list':'trainer', 'content':'trainer'},
    component: () => import('@/components/marketplace/Marketplacelist')
  },
  {
    path: '/:region/marktplatz/verein_gesucht/add',
    name: 'clubformular', // german version
    props: {'form':'club', 'content':'club'},
    component: () => import('@/components/marketplace/Marketplaceform')
  },
  {
    path: '/:region/marktplatz/turniere/add',
    name: 'turnierformular', // german version
    props: {'form':'contest', 'content':'contest'},
    component: () => import('@/components/marketplace/Marketplaceform')
  },
  {
    path: '/:region/marktplatz/trainer_gesucht/add',
    name: 'trainerformular', // german version
    props: {'form':'trainer', 'content':'trainer'},
    component: () => import('@/components/marketplace/Marketplaceform')
  },

  // Shop
  {
    path: '/:region/shop',
    name: 'shopliste', // german version
    props: {'list':'all', 'content':'all'},
    component: () => import('@/components/shop/Shoplist')
  },
  {
    path: '/:region/shop/order',
    name: 'shopformular', // german version
    props: {'form':'all', 'content':'all'},
    component: () => import('@/components/shop/Shopform')
  },

  // Articles for Keyword
  {
    path: '/:keyword',
    name: '', // german version
    component: () => import('@/components/articles/Articles')
  },

  // All invalid routes will redirect here
  {
    path: '*',
    redirect: '/error/404'
  }
]



// WEBPACK FOOTER //
// ./src/routes.js